import { useAppStore } from '@/store/app';
import { getCurrentUserStore } from '@/utils/helper/auth';
import { isRequiredLoginRoute } from '@/utils/helper';

function closeNavMenu() {
	const appStore = useAppStore();
	appStore.updateUserMenuState(false);
	appStore.updateHeaderMenuState(false);
}

function storeAuthRedirect(fullPath: string) {
	const appStore = useAppStore();
	appStore.updateAuthRedirect(fullPath);
}

export default defineNuxtRouteMiddleware(async (to) => {
	closeNavMenu();
	const userStore = getCurrentUserStore();

	if (!userStore.isLoggedIn) {
		if (isRequiredLoginRoute(to.name)) {
			storeAuthRedirect(to.fullPath);

			const router = useRouter();
			router.push({ name: 'auth' });
		}
	}
});
